import type { Operator } from "./Operator";

export interface OperatorFormValues extends Operator {
	AssetIds: number[];
}

export const INITIAL_VALUES: OperatorFormValues = {
	OperatorId: null,
	OperatorName: "",
	AssetIds: [],
	Enabled: true,
	IsActive: true,
};
